import { render } from "./ResearchPage.vue?vue&type=template&id=2fd3a766&scoped=true"
import script from "./ResearchPage.vue?vue&type=script&lang=js"
export * from "./ResearchPage.vue?vue&type=script&lang=js"

import "./ResearchPage.vue?vue&type=style&index=0&id=2fd3a766&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fd3a766"]])

export default __exports__